import { Component, OnInit, Input } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { AuthorizeService } from '../../service/authorize.service'
@Component({
  selector: 'app-trading-average',
  templateUrl: './trading-average.component.html',
  styleUrls: ['./trading-average.component.scss']
})
export class TradingAverageComponent implements OnInit {
  @Input() isFullFactSheet
  @Input() printPage
  subscription: Subscription
  type = []
  value = []
  percent = []
  header = []
  symbol
  asOfDate
  listTrade = []
  ltrade
  listRetail
  listTotal
  listForeign
  listMutual
  listForeignNet
  listHeader
  listHead = []
  round = 4
  checkNoTradingAverage
  constructor(
    private cpmService: CpmService,
    private authorization: AuthorizeService,
    private activatedRoute: ActivatedRoute,
    private store: StoreService
  ) { }

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params

    if (symbol !== undefined && symbol.length > 0) {
      this.getListTradebyIn(symbol)
    }

    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.symbol = response['securitySymbol']
        // tslint:disable-next-line:no-unused-expression
        this.isUserHasPermission ? this.getListTradebyIn(this.symbol) : null
      })
  }

  get isUserHasPermission(): Boolean {
    return (
      this.authorization.hasRole('TRD_INVESTOR_TYPE')
    )
  }

  getListTradebyIn(symbol) {
    this.ltrade = []
    this.type = []
    this.value = []
    this.percent = []
    this.listRetail = []
    this.listForeign = []
    this.listMutual = []
    this.listForeignNet = []

    this.cpmService
      .getSecurityTradingByInvestor(symbol, this.round)
      .then(tradings => {
        this.asOfDate = tradings.asOfDate
        this.listHeader = []
        this.header = []
        this.listHead = []
        const listTradebyIn = tradings.investorType
        listTradebyIn.map(inves => {
          const data = {
            year: inves.year,
            type: inves.investorType,
            value: inves.avgTradingValue,
            percent: inves.percent
          }
          this.ltrade.push(data)
          this.header.push(inves.year.toString())
          this.type.push(inves.investorType)
          this.value.push(inves.avgTradingValue)
          this.percent.push(inves.percent)
        })

        // console.log(this.ltrade, this.header)

        this.header = this.header.reduce(function (a, b) {
          if (a.indexOf(b) < 0) {
            a.push(b)
          }
          return a
        }, [])
        this.type = this.
          type.reduce(function (a, b) {
            if (a.indexOf(b) < 0) {
              a.push(b)
            }
            return a
          }, [])
        this.listHeader = [...this.header]
        this.listHead = []
        this.listHeader.map(head => {
          this.listHead.push(head, '%')
        })

        this.listTrade = []
        listTradebyIn.map(lt => {
          this.header.map(head => {
            this.type.map(t => {
              if (lt.year.toString() === head && lt.investorType === t) {
                const data = {
                  type: t,
                  value: lt.avgTradingValue,
                  netValue: lt.tradingValue,
                  per: lt.percent,
                  year: lt.year
                }
                this.listTrade.push(data)
              }
            })
          })
        })
        this.listRetail = []
        this.listForeign = []
        this.listMutual = []
        this.listTotal = []
        this.listForeignNet = []
        // console.log(' this.listTrade ==', this.listTrade)
        let totallist = [];
        let currentYear = null;
        this.listTrade.map((trade, i) => {
          if (trade.year !== currentYear) {
            if (totallist.length > 0) {
              const totalValue = totallist.reduce((a, b) => a + b, 0);
              this.listTotal.push(totalValue.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ','), 100)
            } else if (currentYear) this.listTotal.push(null);
            currentYear = trade.year
            totallist = [];

          }
          switch (trade.type) {
            case 'Retail':
              this.listRetail.push(
                trade.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                trade.per.toFixed(0)
              )
              totallist.push(trade.value)
              break
            case 'Foreign':
              this.listForeign.push(
                trade.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                trade.per.toFixed(0)
              )
              totallist.push(trade.value)
              break
            case 'Mutual fund + Prop trade':
              this.listMutual.push(
                trade.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                trade.per.toFixed(0)
              )
              totallist.push(trade.value)
              break
            case 'Foreign net buy/sell':
              this.listForeignNet.push(
                trade.netValue.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                trade.per
              )
              break
          }
        })
        if (totallist.length > 0) {
          const totalValue = totallist.reduce((a, b) => a + b, 0);
          this.listTotal.push(totalValue.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ','), 100)
        }
        // console.log(this.listTotal)


        this.listHead.unshift('(M.Baht)')
        if (
          this.listRetail.length === 0 &&
          this.listForeign.length === 0 &&
          this.listMutual.length === 0 &&
          this.listForeignNet.length === 0
        ) {
          return (this.checkNoTradingAverage = true)
        } else {
          if (this.listHead.length - 1 > this.listRetail.length) for (let i = this.listRetail.length; i < this.listHead.length - 1; i++) this.listRetail.push(null);
          if (this.listHead.length - 1 > this.listForeign.length) for (let i = this.listForeign.length; i < this.listHead.length - 1; i++) this.listForeign.push(null);
          if (this.listHead.length - 1 > this.listMutual.length) for (let i = this.listMutual.length; i < this.listHead.length - 1; i++) this.listMutual.push(null);
          if (this.listHead.length - 1 > this.listForeignNet.length) for (let i = this.listForeignNet.length; i < this.listHead.length - 1; i++) this.listForeignNet.push(null);
          if (this.listHead.length - 1 > this.listTotal.length) for (let i = this.listTotal.length; i < this.listHead.length - 1; i++) this.listTotal.push(null);
          return (this.checkNoTradingAverage = false)
        }
      })
  }
  isPositivenumber(value) {
    const num = parseFloat(value)
    return num < 0 ? 'negative' : 'positive'
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/trading-average/trading-average.component.ts